import { Dropdown, Input } from '@sam/components';
import { BankAccountProps } from './BankAccount.types';
import { useTranslation } from 'react-i18next';
import { generateDropdownOptions, useData } from 'shared';
import './BankAccount.scss';
import { IconComponent, IconType } from '../icons/IconComponent';

export const BankAccount: React.FC<BankAccountProps> = ({ account, updateAccount, onDelete }) => {
  const { t } = useTranslation();
  const { data: currencies } = useData('CURRENCY_ALL_ACTIVE', {
    config: { fallbackData: [] },
  });

  return (
    <div className="account-information-wrapper">
      <IconComponent
        type={IconType.DELETE}
        className="account-information-wrapper__delete-icon"
        onClick={onDelete}
      />
      <div className="three-columns">
        <Input
          type="text"
          value={account.owner}
          onChange={(owner) =>
            updateAccount({
              ...account,
              owner,
            })
          }
          label={t('pages.office.edit.owner')}
        />
        <Input
          type="text"
          value={account.institutionName}
          onChange={(institutionName) =>
            updateAccount({
              ...account,
              institutionName,
            })
          }
          label={t('pages.office.edit.institutionName')}
        />
        <Dropdown
          options={generateDropdownOptions(currencies, 'title', 'id')}
          onChange={(currencyId) => updateAccount({ ...account, currencyId })}
          label={t('pages.office.edit.currency')}
          selectedOption={account.currencyId}
        />
        <Input
          type="text"
          value={account.bic}
          onChange={(bic) =>
            updateAccount({
              ...account,
              bic,
            })
          }
          label={t('pages.office.edit.bic')}
        />
        <Input
          type="text"
          value={account.iban}
          onChange={(iban) =>
            updateAccount({
              ...account,
              iban,
            })
          }
          label={t('pages.office.edit.iban')}
        />
      </div>
    </div>
  );
};
